import { useRef } from "react";
import { Grid } from "@mui/material";
import MDButton from "components/MDButton";
import { Fieldset,Texts } from "ui-components/Form";

function ApplyAll({ formValues, setFormValues,setValue=null, details, setDetails }) {
  const doRef = useRef("");
  const invRef = useRef("");

  const handleApply2 = (name) => {
    if(name==="vDONo"){
      if(typeof(doRef.current)==="object") return
    }else{
      if(typeof(invRef.current)==="object") return
    }
    if (formValues !== null) {
      if(name === "vDONo"){
        setFormValues({ ...formValues, [name]: doRef.current });
      }else{
        setFormValues({ ...formValues, [name]: invRef.current });
      }
    }
    if (name === "vDONo") {
      if (doRef.current.trim() === "") return;
      const recvDetails = details.map((detail) => ({ ...detail, vDONo: doRef.current }));
      if(setValue!==null){
        setValue("vDONo",doRef.current)
      }
      setDetails(recvDetails);
    } else {
      if (invRef.current.trim() === "") return;
      const recvDetails = details.map((detail) => ({ ...detail, vInvNo: invRef.current }));
      if(setValue!==null){
        setValue("vInvNo",invRef.current)
      }
      setDetails(recvDetails);
    }
  };
  return (
    <Fieldset label="Apply To All Details">
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <Texts
            field={{ name: "doNo", label: "DO No", ref: doRef, maxLength: 20 }}
            onChange={({ target }) => (doRef.current = target.value)}
          />
        </Grid>
        <Grid item xs={2}>
          <MDButton variant="gradient" color="info" onClick={() => handleApply2("vDONo")}>
            Apply DO NO
          </MDButton>
        </Grid>

        <Grid item xs={4}>
          <Texts
            field={{ name: "invNo", label: "INV No", ref: invRef, maxLength: 20 }}
            onChange={({ target }) => (invRef.current = target.value)}
          />
        </Grid>

        <Grid item xs={2}>
          <MDButton variant="gradient" color="info" onClick={() => handleApply2("vInvNo")}>
            Apply INV NO
          </MDButton>
        </Grid>
      </Grid>
    </Fieldset>
  );
}

export default ApplyAll;
